(() => {
  document.querySelectorAll('[data-prelaunch-countdown]').forEach((countdown) => {
    const launchAt = new Date(countdown.dataset.prelaunchCountdown).getTime();
    const fields = {
      days: countdown.querySelector('[data-days]'),
      hours: countdown.querySelector('[data-hours]'),
      minutes: countdown.querySelector('[data-minutes]'),
      seconds: countdown.querySelector('[data-seconds]'),
    };

    if (!Number.isFinite(launchAt)) {
      countdown.hidden = true;
      return;
    }

    const pad = (value) => String(Math.max(0, value)).padStart(2, '0');
    let timer;
    const update = () => {
      const remaining = launchAt - Date.now();
      if (remaining <= 0) {
        countdown.innerHTML = `<strong class="prelaunch__expired">${countdown.dataset.expiredLabel || 'WE’RE LIVE'}</strong>`;
        window.clearInterval(timer);
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      fields.days.textContent = pad(Math.floor(totalSeconds / 86400));
      fields.hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
      fields.minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      fields.seconds.textContent = pad(totalSeconds % 60);
    };

    timer = window.setInterval(update, 1000);
    update();
  });
})();
